import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GtmRouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    // Ensure dataLayer exists
    window.dataLayer = window.dataLayer || [];

    // Push a GTM-friendly pageview event (works with GA4 tag inside GTM)
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });

    // If you keep direct GA4 (gtag.js), this is optional (GTM approach above is enough)
    // if (window.gtag) {
    //   window.gtag("event", "page_view", {
    //     page_path: location.pathname + location.search,
    //     page_location: window.location.href,
    //     page_title: document.title,
    //   });
    // }
  }, [location.pathname, location.search]);

  return null;
}
